<script>
    import {getGPTransFunc} from "./gp-translations.js";
    import {textFilter, typeFilter, sizeFilter, lightFilter, colorFilter, seasonFilter, promoteExtraPlantPackage} from "./gp-plantpickerstore.js";
    import GPPickerFilter from "./gp-pickerfilter.svelte";

    $: typeFilterValues = $promoteExtraPlantPackage ? [...defTypeFilterValues, {"id": "filterExtraPackage", "label": "Extra plants package", "icon": "extrapackage.svg"}] : defTypeFilterValues;

    let trans = getGPTransFunc("gp-plantpickerfilters");
    let defTypeFilterValues = [
        {"id": "filterAll", "label": "All", "icon": "tree_leafy.svg"},
        {"id": "filterConifer", "label": "Conifers", "icon": "conifer.svg"},
        {"id": "filterTreeLeafy", "label": "Trees", "icon": "tree_leafy.svg"},
        {"id": "filterBushLeafy", "label": "Shrubs", "icon": "bush_leafy.svg"},
        {"id": "filterAzalia", "label": "Azaleas", "icon": "azalia.svg"},
        {"id": "filterCreeper", "label": "Vines", "icon": "creeper.svg"},
        {"id": "filterFlower", "label": "Perennials", "icon": "flower.svg"},
        {"id": "filterSeed", "label": "Bulbs and annuals", "icon": "seed.svg"},
        {"id": "filterVegetables", "label": "Vegs and Herbs", "icon": "vegetable.svg"}
    ];
    let sizeFilterValues = [
        {"id": "filterAll", "label": "All", "icon": "allsizes.svg"},
        {"id": "filterSmall", "label": "Small", "icon": "small.svg"},
        {"id": "filterMedium", "label": "Medium", "icon": "medium.svg"},
        {"id": "filterBig", "label": "Big", "icon": "big.svg"}
    ];
    let lightFilterValues = [
        {"id": "filterAll", "label": "All", "icon": "sun_half.svg"},
        {"id": "filterSun", "label": "Full light", "icon": "sun.svg"},
        {"id": "filterSunHalf", "label": "Half light", "icon": "sun_half.svg"},
        {"id": "filterSunNone", "label": "Shadow", "icon": "sun_none.svg"}
    ];
    let colorFilterValues = [
        {"id": "filterAll", "label": "All", "icon": "azalia-all.svg"},
        {"id": "filterRed", "label": "Red", "icon": "azalia-red.svg"},
        {"id": "filterYellow", "label": "Yellow", "icon": "azalia-yellow.svg"},
        {"id": "filterBlue", "label": "Blue", "icon": "azalia-blue.svg"},
        {"id": "filterWhite", "label": "White", "icon": "azalia-white.svg"},
        {"id": "filterPink", "label": "Pink", "icon": "azalia-pink.svg"},
        {"id": "filterOrange", "label": "Orange", "icon": "azalia-orange.svg"}
    ];
    let seasonFilterValues = [
        {"id": "filterAll", "label": "All", "icon": "cal-bloss.svg"},
        {"id": "filter1", "label": "Jan", "icon": "cal-bloss.svg"},
        {"id": "filter2", "label": "Feb", "icon": "cal-bloss.svg"},
        {"id": "filter3", "label": "Mar", "icon": "cal-bloss.svg"},
        {"id": "filter4", "label": "Apr", "icon": "cal-bloss.svg"},
        {"id": "filter5", "label": "May", "icon": "cal-bloss.svg"},
        {"id": "filter6", "label": "Jun", "icon": "cal-bloss.svg"},
        {"id": "filter7", "label": "Jul", "icon": "cal-bloss.svg"},
        {"id": "filter8", "label": "Aug", "icon": "cal-bloss.svg"},
        {"id": "filter9", "label": "Sep", "icon": "cal-bloss.svg"},
        {"id": "filter10", "label": "Oct", "icon": "cal-bloss.svg"},
        {"id": "filter11", "label": "Nov", "icon": "cal-bloss.svg"},
        {"id": "filter12", "label": "Dec", "icon": "cal-bloss.svg"}
    ];

</script>


<div class="btn-group dropup GPPlantSearchButtons GPSearchButtons">
    <GPPickerFilter componentClass="GPFilerType" filterValues={typeFilterValues} bind:filter={$typeFilter} trans={trans}/>
    <GPPickerFilter componentClass="GPFilerSize" filterValues={sizeFilterValues} bind:filter={$sizeFilter} trans={trans}/>
    <GPPickerFilter componentClass="GPFilerLight" filterValues={lightFilterValues} bind:filter={$lightFilter} trans={trans}/>
    <GPPickerFilter componentClass="GPFilerColors" filterValues={colorFilterValues} bind:filter={$colorFilter} trans={trans}/>
    <GPPickerFilter componentClass="GPFilerCal" filterValues={seasonFilterValues} bind:filter={$seasonFilter} trans={trans}/>

    <div class="GPPlantSearchText GPSearchText">
        <input bind:value={$textFilter} type="text" class="form-control"
               placeholder="{trans('Search for')}..."
               aria-label="{trans('Search for structures')}"/>
    </div>

    <button on:click={() => {$typeFilter = "filterAll"; $sizeFilter = "filterAll"; $lightFilter = "filterAll"; $textFilter = ""; $colorFilter = "filterAll"; $seasonFilter="filterAll"}}
            class="btn btn-default GPSearchClear GPPlantSearchClear" type="button"
            aria-label="{trans('Clear filters')}">×
    </button>

</div>
